import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useMarkdownContentQuery = (
  { enabled }: { enabled?: boolean } = { enabled: true }
) => {
  return useQuery({
    queryKey: ['markdownContent', 'notes-512316664'],
    queryFn: async () => {
      const response = await axios.get('/media/release-notes/notes-512316664.md', {
        responseType: 'text',
      });
      return response.data;
    },
    retry: 1,
    enabled,
  });
};
